// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Color } from '../../../Graphics';
import { PriceType } from '@shared/utils/History/CashItemUtils';
import { MAMode } from '../IndicatorConstants';
import { IndicatorScriptBase } from '../IndicatorScriptBase';
import { LineStyle } from '../IndicatorScriptBaseEnums';
import { InputParameterInteger } from '../InputParamaterClasses/InputParameterInteger';
import { InputParameterCombobox } from '../InputParamaterClasses/InputParameterCombobox';
export class HiloEscandina extends IndicatorScriptBase {
    constructor() {
        super();
        // #region Initialization
        this.DateOfCreation = '02.05.2020';
        this.ExpirationDate = 0;
        this.Version = '';
        this.Password = '66b4a6416f59370e942d353f08a9ae36';
        this.ProjectName = 'HiloEscandina';
        // #endregion
        this.SetIndicatorLine('Trend Up', Color.Blue, 2, LineStyle.Ladder);
        this.SetIndicatorLine('Trend Down', Color.Red, 2, LineStyle.Ladder);
        this.SeparateWindow = false;
        this.priBarCal = false;
        this.mode = [];
        this.tendency = {
            Rise: 1,
            Nuetral: 0,
            Fall: -1
        };
        this.Period = 14;
        super.InputParameter(new InputParameterInteger('Period', 'Period', 0, 1, 99999));
        this.MAType = MAMode.SMA;
        super.InputParameter(new InputParameterCombobox('MAType', 'Type of Moving Average', 1, [
            { SMA: MAMode.SMA },
            { EMA: MAMode.EMA },
            { SMMA: MAMode.SMMA },
            { LWMA: MAMode.LWMA }
        ]));
        this.MAShift = 1;
        super.InputParameter(new InputParameterCombobox('MAShift', 'Adjusted Period', 2, [
            { 'Shift 0': 0 },
            { 'Shift 1': 1 },
            { 'Shift 2': 2 },
            { 'Shift 3': 3 },
            { 'Shift 4': 4 },
            { 'Shift 5': 5 },
            { 'Shift 6': 6 },
            { 'Shift 7': 7 }
        ]));
        this.TendencyControl = 1;
        super.InputParameter(new InputParameterCombobox('TendencyControl', 'Tendency control', 3, [
            { 'Can not return': false },
            { 'Can return': true }
        ]));
    }
    Init() {
        this.IndicatorShortName('HE');
        this.priBarCal = true;
    }
    GetIndicatorShortName() {
        return 'HE';
    }
    getCustomName() {
        return 'HE (' + this.ProjectName + ')';
    }
    createInternalIndicators() {
        this.indMA_Max = this.Indicators.iMA(this.CurrentData, this.Period, this.MAType, this.MAShift, PriceType.High);
        this.indMA_Min = this.Indicators.iMA(this.CurrentData, this.Period, this.MAType, this.MAShift, PriceType.Low);
        return [this.indMA_Max, this.indMA_Min];
    }
    OnQuote() {
        super.OnQuote();
        if (this.CurrentData.Count <= this.Period) {
            return;
        }
        const GraPreClo = this.CurrentData.getPriceByType(PriceType.Close, 0);
        const GraPreOpe = this.CurrentData.getPriceByType(PriceType.Open, 0);
        let ValIndMax = this.indMA_Max.GetValue();
        let ValIndMin = this.indMA_Min.GetValue();
        if (this.priBarCal) {
            this.priBarCal = false;
            this.SetValue(0, 0, ValIndMax);
            this.SetValue(1, 0, ValIndMin);
            if (GraPreClo > GraPreOpe) {
                this.mode[this.mode.length - 1] = this.tendency.Rise;
            }
            else {
                this.mode[this.mode.length - 1] = this.tendency.Fall;
            }
        }
        else {
            const prevHigh = this.GetValue(0, 1);
            const prevLow = this.GetValue(1, 1);
            const prevTendency = this.mode[this.mode.length - 1 - 1];
            if (prevTendency > this.tendency.Nuetral) {
                if (GraPreClo < prevHigh || GraPreOpe < prevHigh) {
                    this.SetValue(0, 0, 0);
                    this.SetValue(1, 0, ValIndMax);
                    this.mode[this.mode.length - 1] = this.tendency.Fall;
                }
                else {
                    ValIndMin = this.TendencyControl ? ValIndMin : Math.max(ValIndMin, prevHigh);
                    this.SetValue(0, 0, ValIndMin);
                    this.SetValue(1, 0, 0);
                    this.mode[this.mode.length - 1] = this.tendency.Rise;
                }
            }
            else {
                if (GraPreClo > prevLow || GraPreOpe > prevLow) {
                    this.SetValue(0, 0, ValIndMin);
                    this.SetValue(1, 0, 0);
                    this.mode[this.mode.length - 1] = this.tendency.Rise;
                }
                else {
                    ValIndMax = this.TendencyControl ? ValIndMax : Math.min(ValIndMax, prevLow);
                    this.SetValue(0, 0, 0);
                    this.SetValue(1, 0, ValIndMax);
                    this.mode[this.mode.length - 1] = this.tendency.Fall;
                }
            }
        }
    }
    NextBar() {
        super.NextBar();
        this.mode.push(0);
    }
}
